




































import { defineComponent } from '@nuxtjs/composition-api'
import { Pagination, Navigation } from 'swiper'
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
SwiperCore.use([Pagination, Navigation])

import HTMLContent from '~/components/solepro/HTMLContent.vue'
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue'

export default defineComponent({
    components: {
        Swiper,
        SwiperSlide,
        HTMLContent
    },
    mixins: [PageBuilderComponent],
    props: {
        node: {
            type: Object,/** define type */
            required: true
        }
    },
    setup(props) {
        const { node: content } = props as Readonly<{ [key: string]: any }>;
        const title = content.children.find(el => el.contentType == 'heading')?.DOMContent.outerHTML;
        const slides = content.children.find(el => el.contentType == 'slider')?.children || []
        const swiperProps = {
            slidesPerView: "auto",
            spaceBetween: 12,
            modules: [Navigation, Pagination],
            slideClass: 'slide',
            pagination: {
                el: '.logos-carousel .pagination',
                type: 'progressbar',
                progressbarFillClass: 'bg-black w-full block h-full'
            },
            navigation: {
                prevEl: '.logos-carousel .navigation-prev',
                nextEl: '.logos-carousel .navigation-next'
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1366: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }
        }

        return {
            swiperProps,
            title,
            slides
        }
    },
    methods: {
        getBgImage(jsonString) {
            const images = JSON.parse(jsonString.replaceAll('\\', ''));
            return images.desktop_image
        },
    }
})
